import BaseControlTypeConst from "./BaseControlTypeConst"

export default class TagTypeConst extends BaseControlTypeConst {
  static VALUE = 'value'
  static SEVERITY = 'severity'
  static ROUNDED = 'rounded'
  static ICON = 'icon'

}
